import { Component, ViewEncapsulation } from '@angular/core';
import {
    HeaderComponent,
    NavComponent,
    FooterComponent,
    NavigationItem
} from '@cvx/nextpage';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent {
  navigationItems: NavigationItem[] = [
    {
        label: 'Formula Optimization',
        link: '/formula-optimization'
    },
    {
        label: 'Blend Calculator',
        link: '/blend-calculator'
    }
  ];

  constructor() {}

}